export default __webpack_public_path__ + "74fb860d921fb3a1e25739715bd3592f.png";